import { ResponseError } from 'shared/common/errors';
import { TGetActiveTypesByBboxResponse } from 'shared/common/repositories/infrastructure-caching/v1/get-active-types-by-bbox';
import { IInfrastructureTypeResponse } from 'shared/common/repositories/infrastructure-caching/entities/infrastructure/InfrastructureTypeResponse';

export function assertFetchGetActiveTypesByBboxResponse(
  response: TGetActiveTypesByBboxResponse,
): asserts response is { statusCode: 200; response: IInfrastructureTypeResponse } {
  if (response.statusCode !== 200) {
    throw new ResponseError({
      message: response.response.message || 'Unknown error',
      domain: 'assertFetchGetActiveTypesResponse',
    });
  }
}
